import React, { useState, useEffect } from "react";
import { Modal, Input, Button, Spin } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import useRequest from "../hooks/useRequest";

const CommentModal = ({ visible, onClose, postId }) => {
  const [list, setList] = useState([]);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const { request } = useRequest();

  const handleChange = (event) => {
    setComment(event.target.value);
  };

  const addPost = () => {
    if (!comment.trim()) return;
    
    setLoading(true);
    request({
      url: `app/post/post-Comment/${postId}`,
      method: "PUT",
      data: { comment: comment },
      onSuccess: (data) => {
        setComment("");
        getComments(postId);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      }
    });
  };

  const getComments = (id) => {
    if (!id) return;
    
    setLoading(true);
    request({
      url: `app/post/getData/${id}`,
      method: "GET",
      onSuccess: (data) => {
        setList(data.data);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      }
    });
  };

  const handleDeleteComment = (commentId) => {
    request({
      url: `app/post/removeComment/${postId}/${commentId}`,
      method: "PUT",
      onSuccess: (data) => {
        getComments(postId);
      },
      onError: (error) => {
        console.log(error);
      }
    });
  };

  useEffect(() => {
    if (visible && postId) {
      getComments(postId);
    }
  }, [visible, postId]);

  const handleModalClose = () => {
    setComment("");
    setList([]);
    onClose();
  };

  return (
    <Modal
      title="Comments"
      open={visible}
      onCancel={handleModalClose}
      footer={null}
      width={600}
      styles={{
        body: { maxHeight: '60vh', overflow: 'hidden' }
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '50vh' }}>
        {/* Comments List */}
        <div style={{ 
          flex: 1, 
          overflowY: 'auto', 
          marginBottom: '16px',
          padding: '0 8px'
        }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <Spin size="large" />
            </div>
          ) : (
            <div>
              {list?.commentInfo?.length > 0 ? (
                list.commentInfo.map((commentData, index) => (
                  <div key={index} style={{ marginBottom: '16px', borderBottom: '1px solid #f0f0f0', paddingBottom: '16px' }}>
                    <div style={{ display: 'flex', gap: '12px' }}>
                      <img
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                        src={
                          commentData?.userId?.profilePic
                            ? `https://pwabucket1.s3.amazonaws.com/${commentData?.userId?.profilePic}`
                            : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              commentData?.userId?.name
                            )}&size=256`
                        }
                        alt={commentData?.userId?.name}
                      />
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <h6 style={{ margin: 0, fontWeight: 'bold' }}>
                            {commentData?.userId?.name}
                          </h6>
                          <Button
                            type="text"
                            icon={<DeleteOutlined />}
                            size="small"
                            onClick={() => handleDeleteComment(commentData._id)}
                            style={{ color: '#ff4d4f' }}
                          />
                        </div>
                        <p style={{ 
                          margin: '4px 0', 
                          fontSize: '12px', 
                          color: '#999' 
                        }}>
                          {new Date(commentData.created_At).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                          })}{' '}
                          {new Date(commentData.created_At).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })}
                        </p>
                        <p style={{ margin: '8px 0 0 0' }}>
                          {commentData.comment}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  No comments yet. Be the first to comment!
                </div>
              )}
            </div>
          )}
        </div>

        {/* Comment Input */}
        <div style={{ 
          display: 'flex', 
          gap: '8px', 
          borderTop: '1px solid #f0f0f0',
          paddingTop: '16px'
        }}>
          <Input
            type="text"
            name="comment"
            value={comment}
            placeholder="Add a comment..."
            onChange={handleChange}
            onPressEnter={addPost}
            disabled={loading}
            style={{ flex: 1 }}
          />
          <Button
            type="primary"
            onClick={addPost}
            loading={loading}
            disabled={!comment.trim()}
          >
            Post
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CommentModal;